import { render, staticRenderFns } from "./SimpleCard.vue?vue&type=template&id=ae20c4bc&scoped=true"
import script from "./SimpleCard.vue?vue&type=script&lang=js"
export * from "./SimpleCard.vue?vue&type=script&lang=js"
import style0 from "./SimpleCard.vue?vue&type=style&index=0&id=ae20c4bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae20c4bc",
  null
  
)

export default component.exports